import HelpdeskGraphQL from "./HelpdeskGraphQL";
import Axios from "axios";

const messageSelector = `
    id
    conversationId
    createdAt
    type
    options
    optionValue

    ... on Text {
        senderId
        senderType
        mediaType
        mediaValue
        attachments
        hideInMessenger
        isDeleted
        mediaFormValue {
            name
            value
            dataType
            groupName
        }
    }
`

class Message extends HelpdeskGraphQL {
    static async getMessages({ conversationId }) {
        const queryName = 'getTextMessages'

        const query = `
            query messages($conversationId: ID) {
                ${queryName}(conversationId: $conversationId) {
                    ${messageSelector}
                }
            }
        `
        const variables = {
            conversationId
        }

        return await this.run({ query, variables, queryName })
    }

    static async createMessage({ id, conversationId, senderId, senderType, mediaType, mediaValue, mediaFormValue, createdAt, type, options, optionValue, operationType = '', channel }) {

        const mutationName = 'createMessage'

        const query = `
            mutation createMessage($message: MessageInput) {
                ${mutationName}(message: $message) {
                    ${messageSelector}
                }
            }
        `
        const variables = {
            message: {
                id, conversationId, senderId, senderType, mediaType, mediaValue, type, options, optionValue, mediaFormValue, lastMessageId: id,
                operationType,
                channel
            }
        }
        if(operationType === 'UPDATED') {
            variables.message.createdAt = createdAt
        }

        return await this.run({ query, variables, queryName: mutationName })
    }

    static async fileDownload(Key) {
        const queryName = 'fileDownload'

        const query = `
            query ${queryName}($Key: String) {
                ${queryName}(Key: $Key)
            }
        `
        const variables = {
            Key
        }

        return await Axios({
            url: this.url,
            method: 'POST',
            responseType: 'blob',
            data: {
                query,
                variables
            }
        })
    }
}

export default Message